module.exports = __webpack_public_path__ + "img/BBSRC.45d3c2cd.png";